import { normalizePetState } from './petStateMachine.js'
import SvgPetRenderer from './SvgPetRenderer.jsx'

function PetRenderer({
  renderer = 'svg',
  state = 'idle',
  ...props
}) {
  const normalizedState = normalizePetState(state)

  if (renderer === 'live2d') {
    return <SvgPetRenderer {...props} state={normalizedState} />
  }

  return <SvgPetRenderer {...props} state={normalizedState} />
}

export default PetRenderer
